import { OperationsConstants } from '../store/operations.constants'

export const operationsSchemas = [
  {
    inputKey: OperationsConstants.SET_LAST_NAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LAST_NAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_LAST_NAME'],
    errorMessage: {
      properties: {
        SET_LAST_NAME: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OperationsConstants.SET_FIRST_NAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_FIRST_NAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_FIRST_NAME'],
    errorMessage: {
      properties: {
        SET_FIRST_NAME: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OperationsConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: OperationsConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
]

export const operationsSecondsSchemas = [
  {
    inputKey: OperationsConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
